
import { AuthStore } from './auth.store';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';


export const loggedOutGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isAuthenticated()) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};